import { createResource, type RouteResource } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';
import type { UserResourceType } from '@atlassian/eoc-resources';
import {
	routingRulesResource,
	type RoutingRulesResponse,
} from '@atlassian/eoc-routing-rules/resources';
import type { GetTimezonesResponse } from '@atlassian/eoc-schedule-common/resources';
import {
	resources as scheduleResources,
	type ScheduleRightsResponse,
	type ScheduleTimeTemplatesResponse,
	type TeamScheduleListResponse,
	type UiPreferencesResponse,
} from '@atlassian/eoc-schedule/resources';

import { getTeam } from '../endpoints';
import type { GetTeamResponse } from '../endpoints/types';

export const getTeamResource: RouteResource<GetTeamResponse> = createResource({
	type: 'getTeamResource',
	getKey: () => 'getTeamResource',
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		assert(
			!!teamId,
			new AssertionError('getTeamResource', 'teamId should be set to fetch on-call'),
		);

		return getTeam(teamId);
	},
	isBrowserOnly: true,
});

export type { GetTeamResponse };

export const resources = (): (
	| RouteResource<GetTeamResponse>
	| RouteResource<TeamScheduleListResponse>
	| RouteResource<UiPreferencesResponse>
	| RouteResource<ScheduleRightsResponse>
	| RouteResource<ScheduleTimeTemplatesResponse>
	| RouteResource<GetTimezonesResponse>
	| RouteResource<UserResourceType>
	| RouteResource<RoutingRulesResponse>
)[] => [...scheduleResources, routingRulesResource, getTeamResource];
